import { i18n } from '@zet/localization'

import en from './en.json'

const availableLanguages = [{ name: 'English', code: 'en' }]

const localizationObj = {
  en,
}

i18n.store(localizationObj)
i18n.defaultLocale = 'en'

export { availableLanguages, i18n }
